import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function FontsActions(props) {
  const { getSelectedExceptDefaultAndUsedFonts, showUploadFontDialog, onDelete } = props;
  const showUploadDropDownTogglerRef = useRef(null);
  const {
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  if (!Writer) {
    return null;
  }

  return (
    <div
      data-test="fonts-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="Upload Fonts" placement="top">
        <button
          data-test="content-selector-add-button"
          ref={showUploadDropDownTogglerRef}
          type="button"
          className="w-[50px] relative cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          onClick={showUploadFontDialog}
        >
          <img
            src="/assets/images/icons/file_upload.svg"
            alt="upload icon"
            className="w-[30px] h-[30px] cursor-pointer"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
      {getSelectedExceptDefaultAndUsedFonts().length > 0 && (
        <ToolTipIcon
          toolText={pluralize('Delete Font', getSelectedExceptDefaultAndUsedFonts().length)}
          placement="top"
        >
          <button
            type="button"
            onClick={onDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
    </div>
  );
}

FontsActions.propTypes = {
  getSelectedExceptDefaultAndUsedFonts: PropTypes.func.isRequired,
  showUploadFontDialog: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  auth: PropTypes.object.isRequired,
};

export default FontsActions;
